import Typography from '@mui/material/Typography';
import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';
import { memo } from 'react';

import {
	LocationCountryText,
	LocationCountryTextProps,
} from 'modules/Shared/Components/OperatingLocation/LocationCountryText';

import { CountryAutoCompleteInput } from '../Inputs/CountryAutoCompleteInput';

const CountryCellInternal = (props: LocationCountryTextProps) => (
	<Typography
		className="MuiDataGrid-cellContent"
		sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
		<LocationCountryText {...props} showCountryCode isDynamicWidth />
	</Typography>
);

export const CountryCell = memo(CountryCellInternal);

export const getFilterOperators = getGridSingleSelectOperators()
	.filter((operator) => operator.value === 'is')
	.map((operator) => ({
		...operator,
		InputComponent: operator.InputComponent
			? CountryAutoCompleteInput
			: undefined,
	}));
